module.exports = __webpack_public_path__ + "static/capsol-2d2514a48d9cf41501d07fb8f2363767.png";